import React from 'react';

import Box from '@mui/material/Box';

import { ReactComponent as ToastIconError } from '../../../assets/icons/toast/toast_error_icon.svg';
import { ReactComponent as ToastDefaultIcon } from '../../../assets/icons/toast/toast_success_icon.svg';
import { ReactComponent as ToastIconWarning } from '../../../assets/icons/toast/toast_warning_icon.svg';

const iconWrapSx = {
  display: 'inline-flex',
  lineHeight: 0,
  '& svg': { display: 'block' },
} as const;

export function ToastSuccessIcon() {
  if (!ToastDefaultIcon) return null;
  return (
    <Box component="span" sx={{ ...iconWrapSx, color: 'success.main' }}>
      <ToastDefaultIcon />
    </Box>
  );
}

export function ToastErrorIcon() {
  if (!ToastIconError) return null;
  return (
    <Box component="span" sx={{ ...iconWrapSx, color: 'error.main' }}>
      <ToastIconError />
    </Box>
  );
}

export function ToastWarningIcon() {
  if (!ToastIconWarning) return null;
  return (
    <Box component="span" sx={{ ...iconWrapSx, color: 'warning.main' }}>
      <ToastIconWarning />
    </Box>
  );
}
